module.exports = __webpack_public_path__ + "img/geoLogo.7def951f.svg";